import { VinaPluginInput } from "../../components/redemption/manage/useVina";
import { DynamoDbList } from "../DynamoDbList";
import { emptyV2Api as api } from "../emptyV2Api";
import { InventoryItem } from "../inventory/InventoryItem";
import { CancelationReq } from "./CancelationReq";
import GetRedemptionDataResponse from "./customer/GetRedemptionDataResponse";
import { JoytelRequest } from "./customer/JoytelRequest";
import { JoytelStatusResponse } from "./customer/JoytelStatusResponse";
import { JoytelUsageResponse } from "./customer/JoytelUsageResponse";
import RedeemRequest from "./customer/RedeemRequest";
import { KycAcknowledgementReq } from "./KycAcknowledgementReq";
import { LpaUploadPluginInput } from "./LpaUploadPluginInput";
import { ManualQrReq } from "./ManualQrReq";
import { QrApiUsageDetailResponse } from "./QrApiUsageDetailResponse";
import { QrApiUsageOverviewResponse } from "./QrApiUsageOverviewResponse";
import { Redemption } from "./Redemption";
import { RedemptionGrouped } from "./RedemptionGrouped";
import { RedemptionGroupedResponse } from "./RedemptionGroupedResponse";
import { RedemptionRequest } from "./RedemptionRequest";
import { RedemptionResponse } from "./RedemptionResponse";
import { ReservationGetReq } from "./ReservationGetReq";
import { ReservationPostReq } from "./ReservationPostReq";
import {
  SalesConfigResponse,
  SalesUpdateRequest,
  SalesUpdateResponse,
} from "./Sales";
import { TelechoicePluginInput } from "./TelechoicePluginInput";
import CryptoJS from 'crypto-js';

import { v4 as uuidv4 } from "uuid";

const SLUG = "/redemption/admin"
const JT_PROXY_BASE_URL = process.env["REACT_APP_ESIM_USAGE_URL"];
const JT_APP_ID = process.env["REACT_APP_ESIM_USAGE_APP_ID"];
const JT_APP_SECRET = process.env["REACT_APP_ESIM_USAGE_APP_SECRET"];

const injectedApi = api
  .enhanceEndpoints({ addTagTypes: ["redemption", "customerRedemption"] })
  .injectEndpoints({
    endpoints: (build) => ({
      getRedemptions: build.query<RedemptionGroupedResponse, RedemptionRequest>({
        query: (x) => {
          const params = new URLSearchParams();
          if (x.lastEvaluatedKey) {
            params.append("lek_oid", x.lastEvaluatedKey.OrderId);
            params.append("lek_sidx", x.lastEvaluatedKey.SimIdx.toString());
          }

          let url = SLUG + "/manage";
          if (params.toString().length > 0) {
            url = url + "?" + params.toString();
          }

          return {
            url: url
          }
        },
        providesTags: ["redemption"],
        transformResponse: (resWrapped: RedemptionResponse) => {

          const res = resWrapped.Items;
          const gs = Object.groupBy(res, x => x.OrderId);
          const rgs = [];
          for (const orderId of Object.keys(gs)) {
            const g: Redemption[] = gs[orderId]!!;
            const rg: any = {};
            rg["orderId"] = orderId;
            rg["orderDate"] = g[0].CreatedAt;
            rg["orderEmail"] = g[0].Email;

            const redeemedCount = g.filter(x => x.Kyc != null).length;
            const totalCount = g.length;
            rg["status"] = `${redeemedCount}/${totalCount}`;

            const sentCount = g.filter(x => x.IsSent).length;
            rg["sentStatus"] = `${sentCount}/${totalCount}`;
            rg["sentCount"] = sentCount;
            rg["kycs"] = g;

            rg["canceled"] = !g.some(x => x.IsCanceled !== true);
            rg["refunded"] = g.some(x => x.IsRefunded === true);
            // rg["canceled"] = true;
            rgs.push(rg as RedemptionGrouped);
          }
          const resp: RedemptionGroupedResponse = {
            data: rgs,
            LastEvaluatedKey: resWrapped.LastEvaluatedKey
          }
          return resp;
        }
      }),
      getRedemptionsRaw: build.query<RedemptionResponse, RedemptionRequest>({
        query: (x) => {
          const params = new URLSearchParams();
          if (x.lastEvaluatedKey) {
            params.append("lek_oid", x.lastEvaluatedKey.OrderId);
            params.append("lek_sidx", x.lastEvaluatedKey.SimIdx.toString());
          }

          let url = SLUG + "/manage";
          if (params.toString().length > 0) {
            url = url + "?" + params.toString();
          }

          return {
            url: url
          }
        },
        providesTags: ["redemption"],
      }),
      getCustomerRedemption: build.query<GetRedemptionDataResponse, RedeemRequest>({
        query: (req) => "redemption/redeem?order_id=" + req.orderId + "&sim_idx=" + req.simIdx,
        providesTags: ["customerRedemption"],
      }),
      getCustomerRedemptionJoytelUsage: build.query<JoytelUsageResponse, JoytelRequest>({
        query: (req) => {
          const timestamp = new Date().getTime();
          const transId = uuidv4();
          const plainText = JT_APP_ID + transId + timestamp + JT_APP_SECRET;
          const cipherText = CryptoJS.MD5(plainText).toString();

          return {
            url: JT_PROXY_BASE_URL + "/esim/usage/query",
            method: "POST",
            headers: {
                "AppId": JT_APP_ID,
                "TransId": transId,
                "Timestamp": timestamp.toString(),
                "Ciphertext": cipherText,
                "Content-Type": "application/json"
              },
            body: req
          }
        }
      }),
      getCustomerRedemptionJoytelStatus: build.query<JoytelStatusResponse, JoytelRequest>({
        query: (req) => {
          const timestamp = new Date().getTime();
          const transId = uuidv4();
          const plainText = JT_APP_ID + transId + timestamp + JT_APP_SECRET;
          const cipherText = CryptoJS.MD5(plainText).toString();

          return {
            url: JT_PROXY_BASE_URL + "/esim/status/query",
            method: "POST",
            headers: {
              AppId: JT_APP_ID,
              TransId: transId,
              Timestamp: timestamp.toString(),
              Ciphertext: cipherText,
            },
            body: req
          }}

      }),
      postTelechoicePlugin: build.mutation<InventoryItem, TelechoicePluginInput>({
        query: (dataMapping) => ({
          url: SLUG + "/plugin/telechoice",
          method: "POST",
          body: dataMapping,
        }),
        invalidatesTags: ["redemption"],
      }),
      postVinaPlugin: build.mutation<InventoryItem, VinaPluginInput>({
        query: (dataMapping) => ({
          url: SLUG + "/plugin/vina",
          method: "POST",
          body: dataMapping,
        }),
        invalidatesTags: ["redemption"],
      }),
      postLpaUploadPlugin: build.mutation<Redemption, LpaUploadPluginInput>({
        query: (input) => ({
          url: SLUG + "/plugin/lpa-upload",
          method: "POST",
          body: input,
        }),
        invalidatesTags: ["redemption", "customerRedemption"],
      }),
      postResendEmail: build.mutation<Redemption, ManualQrReq>({
        query: (req) => ({
          url: SLUG + "/resend",
          method: "POST",
          body: req,
        }),
        invalidatesTags: ["redemption"],
      }),
      postKycAck: build.mutation<Redemption, KycAcknowledgementReq>({
        query: (ack) => ({
          url: SLUG + "/kycack",
          method: "POST",
          body: ack
        }),
        invalidatesTags: ["redemption"]
      }),
      postCancelRedemption: build.mutation<void, CancelationReq>({
        query: (cancelationReq) => ({
          url: SLUG + "/cancel",
          method: "POST",
          body: cancelationReq,
        }),
        invalidatesTags: ["redemption"],
      }),
      getSalesConfig: build.query<SalesConfigResponse, string>({
        query: (orderId) => (
          SLUG + "/sales?orderId=" + encodeURIComponent(orderId)
        ),
      }),
      putSales: build.mutation<SalesUpdateResponse, SalesUpdateRequest>({
        query: (request) => ({
          url: SLUG + "/sales",
          method: "PUT",
          body: request,
        }),
        invalidatesTags: ["redemption"],
      }),
      getReserved: build.query<InventoryItem, ReservationGetReq>({
        query: (rreq) => SLUG + "/reserve?orderId=" + rreq.orderId
                         + "&simIdx=" + rreq.simIdx,
      }),
      postReserved: build.mutation<InventoryItem, ReservationPostReq>({
        query: (rreq) => ({
          url: SLUG + "/reserve",
          method: "POST",
          body: rreq
        }),
        invalidatesTags: ["redemption"]
      }),
      getQrApiUsageOverview: build.query<QrApiUsageOverviewResponse, void>({
        query: () => SLUG + "/qr-api-usage",
      }),
      getQrApiUsageDetail: build.query<QrApiUsageDetailResponse, void>({
        query: () => SLUG + "/qr-api-usage?detail=1",
      }),
    }),
});

export const {
  useGetRedemptionsQuery,
  useLazyGetRedemptionsQuery,
  useGetRedemptionsRawQuery,
  useLazyGetRedemptionsRawQuery,
  useGetCustomerRedemptionQuery,
  useGetCustomerRedemptionJoytelUsageQuery,
  useGetCustomerRedemptionJoytelStatusQuery,
  usePostTelechoicePluginMutation,
  usePostVinaPluginMutation,
  usePostLpaUploadPluginMutation,
  usePostResendEmailMutation,
  usePostKycAckMutation,
  usePostCancelRedemptionMutation,
  useGetSalesConfigQuery,
  usePutSalesMutation,
  useGetReservedQuery,
  useLazyGetReservedQuery,
  usePostReservedMutation,
  useGetQrApiUsageOverviewQuery,
  useGetQrApiUsageDetailQuery
} = injectedApi;
